import type { DesignTokens } from './tokens';

/**
 * The design tokens as CSS custom properties, for stylesheets that cannot read the JS theme
 * (the Mockup logs dashboard CSS, the Tailwind-built Print File Review page). Set them inline on
 * the page root (`style={themeCssVars(theme.custom)}`) and read them with `var(--name)`.
 */
export const themeCssVars = (tokens: DesignTokens): Record<string, string> => {
    const { color, radius, shadow, font } = tokens;
    return {
        '--bg': color.canvas,
        '--surface': color.surface,
        '--surface-muted': color.surfaceMuted,
        '--surface-raised': color.surfaceRaised,
        '--border': color.border,
        '--border-strong': color.borderStrong,
        '--text': color.text.primary,
        '--text-muted': color.text.secondary,
        '--text-dim': color.text.muted,
        '--primary': color.primary.main,
        '--primary-hover': color.primary.hover,
        '--primary-soft': color.primary.soft,
        '--primary-on-soft': color.primary.onSoft,
        '--on-primary': color.primary.contrast,
        '--success': color.tone.success.main,
        '--success-soft': color.tone.success.soft,
        '--success-on-soft': color.tone.success.onSoft,
        '--warn': color.tone.warning.main,
        '--warn-soft': color.tone.warning.soft,
        '--warn-on-soft': color.tone.warning.onSoft,
        '--danger': color.tone.danger.main,
        '--danger-soft': color.tone.danger.soft,
        '--danger-on-soft': color.tone.danger.onSoft,
        '--info': color.tone.info.main,
        '--info-soft': color.tone.info.soft,
        '--info-on-soft': color.tone.info.onSoft,
        '--neutral': color.tone.neutral.main,
        '--neutral-soft': color.tone.neutral.soft,
        '--neutral-on-soft': color.tone.neutral.onSoft,
        '--overlay': color.overlay,
        '--gradient-brand': color.gradient.brand,
        '--shadow': shadow.sm,
        '--radius': `${radius.lg}px`,
        '--radius-sm': `${radius.sm}px`,
        '--font': font.family,
        '--tooltip-bg': color.tooltip.bg,
        '--tooltip-text': color.tooltip.text,
        '--focus': color.focusRing,
    };
};
